import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
// import { NativePageTransitions, NativeTransitionOptions } from '@ionic-native/native-page-transitions/ngx';
import { NavController, Platform } from '@ionic/angular';

// const transOptions: NativeTransitionOptions = {
//   direction: 'up',
//   // duration: 500,
//   slowdownfactor: 3,
//   slidePixels: 20,
//   iosdelay: 100,
//   androiddelay: 150,
//   fixedPixelsTop: 0,
//   fixedPixelsBottom: 60,
//  };

@Injectable()
export class NavService {

    constructor(
      private navCtrl: NavController,
      private platform: Platform,
//      private nativePageTransitions: NativePageTransitions,
      private router: Router,
    ) { }

    public push(route: string, params?: any): Promise<boolean> {
      const options = params ? {state: params} : {};
      if (this.platform.is('android')) {
//        this.nativePageTransitions.fade(transOptions);
      } else if (this.platform.is('ios')) {
        options['animated'] = false;
      }
      return this.navCtrl.navigateForward(route, options);
    }

    public pop(): Promise<boolean> {
      return this.navCtrl.pop();
    }

    public root(route: string, params?: any): Promise<boolean> {
      const options = params ? {state: params} : {};
      if (this.platform.is('android')) {
//        this.nativePageTransitions.fade(transOptions);
      } else if (this.platform.is('ios')) {
        options['animated'] = false;
      }
      return this.navCtrl.navigateRoot(route, options);
    }

    public get(param: string): any {
      const state = this.router.getCurrentNavigation()?.extras?.state;
      return state !== undefined && state[param] !== undefined ? state[param] : undefined;
    }

    public getCurrentRoute(): any {
      return this.router.url;
    }

}
